import 'css-chunksrc/client/scenes/projectCreationForm/zoneSelection/styles.scss';export default {
  "zoneSelection": "_zoneSelection_1hxax_1",
  "input": "_input_1hxax_5",
  "selectedZone": "_selectedZone_1hxax_17",
  "opened": "_opened_1hxax_23",
  "toggleArrow": "_toggleArrow_1hxax_27",
  "name": "_name_1hxax_31",
  "placeholder": "_placeholder_1hxax_40",
  "listRoot": "_listRoot_1hxax_53",
  "list": "_list_1hxax_53",
  "item": "_item_1hxax_72",
  "zone": "_zone_1hxax_1",
  "selected": "_selected_1hxax_17",
  "folderIcon": "_folderIcon_1hxax_92"
};